export const CSV_WARNINGS = [
  { content: 'You need a column called "key"', as: 'p', isDisplayed: 'keyWarning' },
  { content: 'All columns must have names', as: 'p', isDisplayed: 'headerValueWarning' },
];
